import { render, staticRenderFns } from "./category-tree-list-item.vue?vue&type=template&id=5c2ff4e8&"
import script from "./category-tree-list-item.vue.ts?vue&type=script&lang=ts&"
export * from "./category-tree-list-item.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports